import { useChatStore } from '../store/useChatStore';

export default function ConversationList() {
  const { conversations, activeConversationId, selectConversation, newConversation, deleteConversation } =
    useChatStore();

  const formatAge = (iso) => {
    const diff = Date.now() - new Date(iso).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 60) return `${mins}m ago`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h ago`;
    return `${Math.floor(hrs / 24)}d ago`;
  };

  return (
    <aside style={{
      width: 'var(--gqs-conv-w)',
      borderRight: '1px solid var(--gqs-border)',
      display: 'flex',
      flexDirection: 'column',
      background: 'var(--gqs-surface)',
      flexShrink: 0,
      overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        padding: '10px 10px 8px',
        borderBottom: '1px solid var(--gqs-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--gqs-text-muted)', letterSpacing: '0.6px', textTransform: 'uppercase' }}>
          Searches
        </span>
        <button
          onClick={newConversation}
          title="New conversation"
          aria-label="New conversation"
          style={{
            background: 'transparent',
            border: '1px solid var(--gqs-border)',
            borderRadius: 5,
            width: 22,
            height: 22,
            cursor: 'pointer',
            color: 'var(--gqs-text-muted)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 16,
            lineHeight: 1,
          }}
        >+</button>
      </div>

      {/* List */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '4px 0' }}>
        {conversations.length === 0 && (
          <p style={{ color: 'var(--gqs-text-muted)', fontSize: 12, padding: '16px 12px', textAlign: 'center' }}>
            No searches yet
          </p>
        )}
        {conversations.map((conv) => (
          <div
            key={conv.id}
            onClick={() => selectConversation(conv.id)}
            style={{
              padding: '8px 10px',
              cursor: 'pointer',
              background: activeConversationId === conv.id ? 'var(--gqs-accent-soft-strong)' : 'transparent',
              borderLeft: activeConversationId === conv.id ? '2px solid var(--gqs-accent)' : '2px solid transparent',
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              transition: 'background 0.12s',
            }}
            onMouseEnter={(e) => {
              if (activeConversationId !== conv.id) e.currentTarget.style.background = 'var(--gqs-hover)';
            }}
            onMouseLeave={(e) => {
              if (activeConversationId !== conv.id) e.currentTarget.style.background = 'transparent';
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
              <span style={{
                flex: 1,
                fontSize: 12,
                fontWeight: activeConversationId === conv.id ? 600 : 400,
                color: activeConversationId === conv.id ? 'var(--gqs-text)' : 'var(--gqs-text-muted)',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                lineHeight: 1.4,
              }}>
                {conv.title}
              </span>
              <button
                onClick={(e) => { e.stopPropagation(); deleteConversation(conv.id); }}
                title="Delete"
                aria-label="Delete conversation"
                style={{
                  background: 'transparent', border: 'none',
                  color: 'var(--gqs-text-muted)', cursor: 'pointer',
                  opacity: 0.4, fontSize: 13, lineHeight: 1,
                  flexShrink: 0,
                }}
              >×</button>
            </div>
            <span style={{ fontSize: 10, color: 'var(--gqs-text-muted)', opacity: 0.7 }}>
              {formatAge(conv.updatedAt)}
              {conv.lastWorkflowId && (
                <span style={{
                  marginLeft: 5,
                  background: 'var(--gqs-accent-soft)',
                  borderRadius: 3,
                  padding: '0 4px',
                  fontSize: 9,
                  color: 'var(--gqs-accent)',
                }}>{conv.lastWorkflowId.slice(0, 8)}</span>
              )}
            </span>
          </div>
        ))}
      </div>
    </aside>
  );
}
